<template>
  <div :class="{ active: isActive }" class="carousel-item">
    <!--    EXTERNAL_LINK : 外部連結    -->
    <a
      v-if="banner.type && banner.type === 'EXTERNAL_LINK'"
      :href="banner.url"
      target="_blank"
      rel="noopener"
    >
      <img v-bind="imgAttrs" :alt="banner.title" />
    </a>
    <!--    NO_USE: 不使用連結    -->
    <a v-else-if="banner.type && banner.type === 'NO_USE'" href="#">
      <img v-bind="imgAttrs" :alt="banner.title" />
    </a>
    <!--    INTERNAL_LINK : 內部連結    -->
    <nuxt-link
      v-else-if="banner.type && banner.type === 'INTERNAL_LINK'"
      :to="banner.url"
    >
      <img v-bind="imgAttrs" :alt="banner.title" />
    </nuxt-link>
    <!--    PROMOTION: 到優惠頁面    -->
    <nuxt-link v-else :to="`promotion/${banner.url}`">
      <img v-bind="imgAttrs" :alt="banner.title" />
    </nuxt-link>
  </div>
</template>
<script>
import { computed, defineComponent, toRef } from '@nuxtjs/composition-api'

export default defineComponent({
  name: 'BannerItem',
  props: {
    name: {
      type: String,
      default: 'BannerItem'
    },
    banner: {
      type: Object,
      required: true
    },
    isActive: {
      type: Boolean,
      default: false
    },
    isMobile: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    const isActive = toRef(props, 'isActive')
    const isMobile = toRef(props, 'isMobile')
    const banner = toRef(props, 'banner')
    const imgAttrs = computed(() => {
      const result = {}
      result[isActive.value ? 'src' : 'data-src'] = !isMobile.value
        ? banner.value.imgPath
        : banner.value.mobileImgPath
      return result
    })
    return {
      imgAttrs
    }
  }
})
</script>
